import { render } from "./Auth.vue?vue&type=template&id=247affc3"
import script from "./Auth.vue?vue&type=script&lang=js"
export * from "./Auth.vue?vue&type=script&lang=js"
script.render = render

export default script